export const clientUsage = /* GraphQL */ `
  query clientUsage($clientId: ID) {
  clientUsage(clientId: $clientId) {
      aiUsageCount
      clientId
      itemsCount
      quizzesCount
  }
}
`;

export const getClient = /* GraphQL */ `
  query getClient($id: ID!) {
  getClient(id: $id) {
      createdAt
      created_at
      customer_id
      defaultWorkspaces
      deletedAt
      id
      inviteLink
      meta
      name
      ownerUserId
      slug
      subscription_details
      subscription_endsAt
      subscription_plan
      subscription_status
      updatedAt
      userRole
      version
  }
}
`;

export const getPushSubscriptions = /* GraphQL */ `
  query getPushSubscriptions {
  getPushSubscriptions {
      createdAt
      endpoint
      id
      lastUsedAt
      userId
  }
}
`;

export const hybridSearch = /* GraphQL */ `
  query hybridSearch($query: String!, $embedding: [Float!]!, $workspaceId: ID, $filters: SearchFilters, $options: SearchOptions) {
  hybridSearch(query: $query, embedding: $embedding, workspaceId: $workspaceId, filters: $filters, options: $options) {
      items {
        id
        itemId
        score
        similarity
        snippet
        title
        workspaceId
      }
      totalCount
  }
}
`;

export const listClientUsers = /* GraphQL */ `
  query listClientUsers($filter: ModelClientUserFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
  listClientUsers(filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items {
        avatarPath
        closedAt
        createdAt
        deletedAt
        email
        id
        isAdmin
        isConfirmed
        isReadOnly
        lastActive
        name
        ownerId
        roleUpdatedBy
        roles
        sub
        surname
        updatedAt
        version
      }
      nextToken
      startedAt
  }
}
`;

export const listItems = /* GraphQL */ `
  query listItems($id: ID, $filter: ModelItemFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
  listItems(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items {
        ackUpdatedBy
        acknowledgement
        acknowledgementRequired
        archived
        childIds
        createdAt
        creator
        deletedAt
        description
        id
        name
        ownerId
        parentIds
        pinned
        pinnedIds
        readRoles
        statusRestoreParentIds
        statusSourceLibraryId
        statusUpdatedBy
        trashed
        type
        updatedAt
        updatedBy
        version
        workspaceId
        writeRoles
      }
      nextToken
      startedAt
  }
}
`;

export const listPayments = /* GraphQL */ `
  query listPayments($filter: TablePaymentFilterInput, $limit: Int, $nextToken: String) {
  listPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        billing_period
        createdAt
        currencyCode
        gateway
        invoice_number
        invoice_s3_path
        ownerId
        payments
        totals
        transactionId
        transaction_items
        transaction_status
        updatedAt
      }
      nextToken
  }
}
`;

export const listWorkspaces = /* GraphQL */ `
  query listWorkspaces($id: ID, $filter: ModelWorkspaceFilterInput, $limit: Int, $nextToken: String, $sortDirection: ModelSortDirection) {
  listWorkspaces(id: $id, filter: $filter, limit: $limit, nextToken: $nextToken, sortDirection: $sortDirection) {
      items {
        archivedIds
        avatarPath
        childIds
        createdAt
        deletedAt
        id
        name
        ownerId
        pinnedIds
        slug
        trashedIds
        updatedAt
        version
      }
      nextToken
      startedAt
  }
}
`;

export const notifByUser = /* GraphQL */ `
  query notifByUser($ownerId: ID!, $userIdCreatedAt: ModelNotificationByClientCompositeKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelNotificationFilterInput, $limit: Int, $nextToken: String) {
  notifByUser(ownerId: $ownerId, userIdCreatedAt: $userIdCreatedAt, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        channelAttempts
        createdAt
        deletedAt
        eventId
        id
        initiatorId
        meta
        ownerId
        status
        type
        updatedAt
        userId
      }
      nextToken
      startedAt
  }
}
`;

export const searchDocuments = /* GraphQL */ `
  query searchDocuments($query: String!, $workspaceId: ID, $filters: SearchFilters, $options: SearchOptions) {
  searchDocuments(query: $query, workspaceId: $workspaceId, filters: $filters, options: $options) {
      items {
        id
        itemId
        score
        similarity
        snippet
        title
        workspaceId
      }
      totalCount
  }
}
`;

export const vectorSearch = /* GraphQL */ `
  query vectorSearch($embedding: [Float!]!, $workspaceId: ID, $filters: SearchFilters, $options: SearchOptions) {
  vectorSearch(embedding: $embedding, workspaceId: $workspaceId, filters: $filters, options: $options) {
      items {
        id
        itemId
        score
        similarity
        snippet
        title
        workspaceId
      }
      totalCount
  }
}
`;

export const wsUserByUserId = /* GraphQL */ `
  query wsUserByUserId($ownerId: ID!, $userId: ModelIDKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelWorkspaceUserFilterInput, $limit: Int, $nextToken: String) {
  wsUserByUserId(ownerId: $ownerId, userId: $userId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        createdBy
        deletedAt
        id
        ownerId
        role
        updatedAt
        updatedBy
        userId
        version
        workspaceId
      }
      nextToken
      startedAt
  }
}
`;

export const wsUserByWsId = /* GraphQL */ `
  query wsUserByWsId($ownerId: ID!, $workspaceIdUserId: ModelWorkspaceUserByWorkspaceCompositeKeyConditionInput, $sortDirection: ModelSortDirection, $filter: ModelWorkspaceUserFilterInput, $limit: Int, $nextToken: String) {
  wsUserByWsId(ownerId: $ownerId, workspaceIdUserId: $workspaceIdUserId, sortDirection: $sortDirection, filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        createdBy
        deletedAt
        id
        ownerId
        role
        updatedAt
        updatedBy
        userId
        version
        workspaceId
      }
      nextToken
      startedAt
  }
}
`;
